export const mutations = {
    setResult: (state, payload) => {
        state.result = payload;
        state.orderedBankIds = [];
    },
    setOrder(state, ids) {
        state.orderedBankIds = ids;
    },
    setSort(state, payload) {
        state.sortField = payload.field;
        state.sortDirection = payload.direction;
    },
    toggleExpandAll: (state) => {
        state.expandAll = !state.expandAll;
    },
    setCurrentView: (state, view) => {
        state.currentView = view;
    },
    toggleComparedBank: (state, bankId) => {
        const index = state.comparedBanks.indexOf(bankId);
        if (index !== -1) {
            state.comparedBanks.splice(index, 1);
        }
        else {
            state.comparedBanks.push(bankId);
        }
    },
    toggleHiddenBank: (state, bankId) => {
        const index = state.hiddenBanks.indexOf(bankId);
        if (index !== -1) {
            state.hiddenBanks.splice(index, 1);
        }
        else {
            state.hiddenBanks.push(bankId);
        }
    },
};
